import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import Text from './Text';
import Spacer from './Spacer';
import { rem } from './values';
import Squircle from './Squircle';
import { CardView } from './CardView';
import IconCheck from './icons/IconCheck';
const InfoRow = ({ title }) => {
    const colors = useColors();
    return (<View style={styles.infoRow}>
      <Squircle width={24} height={24} color={colors.buttons.brandGroup}>
        <IconCheck thick width={16} height={16} color={colors.elements.brand}/>
      </Squircle>
      <Spacer w={8}/>
      <View style={styles.flex}>
        <Text TextThin-14 Secondary>
          {title}
        </Text>
      </View>
    </View>);
};
const CardWithChecklist = ({ title, footer, checkList, }) => (<CardView withPadding noMarginTop>
    <Text Text-16>{title}</Text>
    <Spacer h={8}/>
    <View>
      {checkList.map((listItem, index) => (<InfoRow title={listItem} key={String(index)}/>))}
    </View>
    {!!footer && footer}
  </CardView>);
export default memo(CardWithChecklist);
const styles = StyleSheet.create({
    infoRow: {
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: rem(8),
    },
    flex: {
        flex: 1,
    },
});
